export const deleteTagNote =
  "Deleting these tags would remove it from all the assets which it is connected to. Do you want to migrate these to some other tag?";
